import script from "./WikipediaContent.vue?vue&type=script&setup=true&lang=js"
export * from "./WikipediaContent.vue?vue&type=script&setup=true&lang=js"

import "./WikipediaContent.vue?vue&type=style&index=0&id=3d59563a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d59563a"]])

export default __exports__